import React from "react";

export default function Page_UserProfile() {
  return <div>Page_UserProfile</div>;
}
